import React from 'react';
import styled from 'styled-components';
import Hero from 'components/Hero';
import { Content } from 'components/Layout';

const HeroBgVideo = `/overview_hero.mp4`;

const PlatformOverview = () => {
  const title = 'Platform Overview';
  const subtitle = `AI-Empowered Discovery of Peptide and Small Molecule Drugs.`;

  return (
    <PlatformOverviewPage>
      <Hero title={title} subtitle={subtitle} videoSrc={HeroBgVideo} />

      <Content>
        <p>
          Genion Quantum Technologies is committed to advancing LLM-based incremental training, seamlessly integrating the latest drug data to continuously fine-tune models and enhance predictive performance. Covering over 50,000 biological targets, the platform serves as a flexible and efficient tool for accelerating drug discovery.
        </p>
        <p>
          In molecular generation and lead optimization, Genion Quantum Technologies significantly outperforms traditional AI models. By combining quantum mechanics (QM) with molecular graph–based structure elucidation techniques, the platform enables precise molecular structure refinement, effectively overcoming the limitations of conventional algorithms.
        </p>
        <p>
          In the field of protein-protein interactions (PPI), Genion Quantum Technologies has developed an advanced peptide design and optimization platform powered by LLM architecture and geometry-based modeling technologies. By integrating multiple embedded PPI predictive models, the platform offers powerful capabilities for peptide-based drug development and targets identification.
        </p>
        <p>
          Demonstrating high accuracy in molecular design, the platform reliably reproduces experimentally validated active molecules outside the training set, achieving reproduction rates well above industry benchmarks. By accelerating the development of both innovative and generic drugs, it reduces R&D costs, improves success rates, and delivers novel AI-QM–driven solutions for molecular design with broad applications across drug discovery.
        </p>
      </Content>
    </PlatformOverviewPage>
  );
};

// 🧱 Page Wrapper
const PlatformOverviewPage = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export default PlatformOverview;